<template>
    <a
        @click="handleClick"
        :href="link.url"
        :target="link.target"
        :data-uuid="settings.uuid"
        :style="linkStyle"
        class="widget-link"
    >
        {{ settings.general.text }}
    </a>
</template>

<script>
import { allEvents, resolveFont, resolveMargin, resolvePadding } from "../utils/style"
import ViewMixin from "../utils/view-mixin"

export default {
    props: {
        settings: {
            type: Object,
            default: () => {}
        }
    },
    mixins: [ViewMixin],
    name: "WidgetLink",
    computed: {
        desktop() {
            return this.settings.desktop
        },
        mobile() {
            return this.settings.mobile
        },
        general() {
            return this.settings.general
        },
        link() {
            return this.settings.link
        },
        linkStyle() {
            return {
                outline: "none",
                border: "none",
                cursor: "pointer",
                color: "#3965FF",
                textDecoration: "underline",
                textUnderlineOffset: "1px",
                display: "block",
                ...allEvents(),
                ...this.resolveStyle(
                    {
                        ...resolveFont(this.desktop.font),
                        ...resolvePadding(this.desktop.padding),
                        ...resolveMargin(this.desktop.margin)
                    },
                    {
                        ...resolveFont(this.mobile.font),
                        ...resolvePadding(this.mobile.padding),
                        ...resolveMargin(this.mobile.margin)
                    }
                )
            }
        }
    },
    methods: {
        handleClick(ev) {
            if (this.isDevMode()) {
                ev.preventDefault()
            }
        },
        isDevMode() {
            return window.builder_dev_mode
        }
    }
}
</script>
